module.exports = __webpack_public_path__ + "img/front_16.d9576390.svg";